// extracted by mini-css-extract-plugin
module.exports = {"imageWrapper":"Image_imageWrapper__tF3gQ","imageAnimationWrapper":"Image_imageAnimationWrapper__MreZP","scale":"Image_scale__dehiU"};